import React from 'react'
import {withRouter} from 'react-router-dom'

const HeaderPublico = (props) => {

    const login = () => {
        props.history.push('/login')
}

    return (
        <nav className="navbar navbar-expand-sm navbar-dark bg-dark">
            <a className="navbar-brand" href="/">Punto 5</a>
            <button className="navbar-toggler d-lg-none" type="button" data-toggle="collapse" data-target="!#collapsibleNavId" aria-controls="collapsibleNavId"
                aria-expanded="false" aria-label="Toggle navigation"></button>
            <div className="collapse navbar-collapse" id="collapsibleNavId">
                <ul className="navbar-nav mr-auto mt-2 mt-lg-0">
                    {/* <li className="nav-item active">
                        <a className="nav-link" href="/">Inicio <span className="sr-only">(current)</span></a>
                    </li>
                    <li className="nav-item">
                        <a className="nav-link" href="/nosotros">Nosotros</a>
                    </li> */}
                </ul>
                <button 
                className="btn btn-dark" 
                type="button"
                onClick = {() => login()}
                >
                Login
                </button>
            </div>
        </nav>
    )
}

export default withRouter(HeaderPublico)

